<template>
  <div class="distribution-chart">
    <div
      v-if="!items.length"
      class="distribution-chart__empty"
    >
      {{ emptyText }}
    </div>
    <vue-apex-charts
      v-else
      type="bar"
      :height="chartHeight"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DistributionBarChart',
  components: { VueApexCharts },
  props: {
    // [{ label, hex_color, total }]
    items: { type: Array, default: () => [] },
    seriesName: { type: String, default: '' },
    emptyText: { type: String, default: '—' },
  },
  computed: {
    isDark() {
      return this.$store.state.appConfig.layout.skin === 'dark'
    },
    chartHeight() {
      return Math.max(160, this.items.length * 44 + 40)
    },
    series() {
      return [{ name: this.seriesName, data: this.items.map(i => i.total) }]
    },
    options() {
      const fore = this.isDark ? '#d0d2d6' : '#5e5873'
      return {
        chart: {
          toolbar: { show: false },
          animations: { enabled: false },
          foreColor: fore,
          fontFamily: 'inherit',
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true,
            borderRadius: 4,
            barHeight: '70%',
            dataLabels: { position: 'center' },
          },
        },
        colors: this.items.map(i => i.hex_color),
        dataLabels: {
          enabled: true,
          style: { fontSize: '14px', fontWeight: 700 },
          dropShadow: { enabled: true, blur: 2, opacity: 0.6 },
        },
        legend: { show: false },
        grid: {
          borderColor: this.isDark ? '#3b4253' : '#ebe9f1',
          xaxis: { lines: { show: true } },
          yaxis: { lines: { show: false } },
        },
        xaxis: {
          categories: this.items.map(i => i.label),
          labels: { formatter: v => (Number.isInteger(v) ? v : '') },
        },
        yaxis: { labels: { style: { fontSize: '13px', fontWeight: 600 } } },
        tooltip: { theme: this.isDark ? 'dark' : 'light' },
        states: { hover: { filter: { type: 'none' } } },
      }
    },
  },
}
</script>

<style scoped>
.distribution-chart__empty {
  padding: 32px 0;
  text-align: center;
  color: #b9b9c3;
}
</style>
